
export const KEY_TYPES = {
    PICC: '1',
    APERIO_MASTER: '2',
    DESFIRE_APP_MASTER: '3',
    DESFIRE_READ_WRITE: '4'
};

export const MANAGE_KEYS = {
    IMPORT_KEY: '0',
    GENERATE_KEY: '1',
    EXPORT_KEY: '2'
};
